import { useState, useMemo, useCallback, useEffect } from 'react';

import { Modal } from 'semantic-ui-react';
import PubSub from 'pubsub-js';

import { useMediaQueryStyles } from '$app/common/utils/mediaQueries';
import RegistrationContext from '../contexts/Registration.context';
import Registration from '../topics/RegistrationPage.topic';
import RegistrationPage from '../containers/RegistrationPage.container';

const CTA = ({ ...ctaProps }) => {
  const [visible, setVisible] = useState(false);
  const [cache, setCache] = useState({});

  const handleOpen = useCallback(() => {
    setVisible(true);
  }, []);

  const handleClose = useCallback(
    options => {
      setVisible(false);
      // eslint-disable-next-line babel/no-unused-expressions
      cache?.onClose?.(options);
    },
    [cache],
  );

  const contextValue = useMemo(
    () => ({
      open: handleOpen,
      close: handleClose,
      cache,
    }),
    [handleOpen, handleClose, cache],
  );

  useEffect(() => {
    const subscription = PubSub.subscribe(Registration.OPEN, (_, config) => {
      setCache(config);
      handleOpen();
    });
    return () => {
      PubSub.unsubscribe(subscription);
    };
  }, [handleOpen]);

  return (
    <Modal
      open={visible}
      onOpen={() => {
        setVisible(true);
      }}
      onClose={() => {
        setVisible(false);
      }}
      size="tiny"
      css={useMediaQueryStyles({
        padding: { xs: 20, sm: 50 },
      })}
    >
      <RegistrationContext.CTA.Provider value={contextValue}>
        <RegistrationPage {...ctaProps} />
      </RegistrationContext.CTA.Provider>
    </Modal>
  );
};

export default CTA;
